<template>
<div class="cooperative">
  <div class="container">
    <div :class="{list:true,lister:listshow}">
      <span class="title">
        {{coop.COOP_TITLE}}
      </span>
      <div class="text">
        {{coop.COOP_TEXT}}
      </div>
    </div>
    <div class="partner">
    <!-- <div :class="{join:true,joiner:joinershow}"> -->
      <div :class="{item:true,itemer:itemershow}">
        <div class="itemimg"
        v-for="(img, idx) in partner"
        :key="idx" >
          <img class="itimg" :src="img.img" alt="">
        </div>
        <!-- <div class="itemimg">
          <img class="itimg" src="https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/hbhaoheng/hezuo/zhongjianbaju.jpg" alt="">
        </div>
        <div class="itemimg">
          <img class="itimg" src="https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/hbhaoheng/hezuo/zhongguoershierzhi.png" alt="">
        </div>
        <div class="itemimg">
          <img class="itimg" src="https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/hbhaoheng/hezuo/zhongtieershisiju.png" alt="">
        </div>
        <div class="itemimg">
          <img class="itimg" src="https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/hbhaoheng/hezuo/zhongjiaoerhangju.jpg" alt="">
        </div>
        <div class="itemimg">
          <img class="itimg" src="https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/hbhaoheng/hezuo/jiangxijiangong.png" alt="">
        </div>
        <div class="itemimg">
          <img class="itimg" src="https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/hbhaoheng/hezuo/hubeibaoye.png" alt="">
        </div>
        <div class="itemimg">
          <img class="itimg" src="https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/hbhaoheng/hezuo/wuhanjiangong.png" alt="">
        </div>
        <div class="itemimg">
          <img class="itimg" src="https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/hbhaoheng/hezuo/biguiyuan.png" alt="">
        </div>
        <div class="itemimg">
          <img class="itimg" src="https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/hbhaoheng/hezuo/shanhejianshe.png" alt="">
        </div>
        <div class="itemimg">
          <img class="itimg" src="https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/hbhaoheng/hezuo/huaqiaocheng.png" alt="">
        </div>
        <div class="itemimg">
          <img class="itimg" src="https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/hbhaoheng/hezuo/hubeichanganjianshe.png" alt="">
        </div> -->
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      coop: [],
      partner: [],
      listshow: false,
      itemershow: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    axios.get(`https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/configes.json`)
      .then(response => {
        this.partner = response.data.COOP.PARTNER
        this.coop = response.data.COOP
        // console.log(this.cont)
      })
  },
  methods: {
    handleScroll () {
      // console.log(this.currentScroll)
      // this.currentScroll = window.innerHeight
      this.currentScroll = window.pageYOffset
      // console.log(window.pageYOffset, this.currentScroll)
      if (this.currentScroll >= 2800) {
        // console.log(this.currentScroll)
        this.listshow = true
      }
      if (this.currentScroll >= 2900) {
        this.itemershow = true
      }
    }
  }
  // },
  // methods: {
  //   more: function (event) {
  //     window.location.href = '#/scope'
  //   }
  // }
}
</script>

<style lang="less" scoped>
@import url('../../static/less/less.css');
@media only screen and (min-width: 960px) {
  .itemimg {
    width: 21%;
    // float: left;
    margin: 2%;
  }
}
@media only screen and (min-width: 767px) and (max-width: 960px) {
  .itemimg {
    width: 21%;
    // float: left;
    margin: 2%;
  }
}
@media only screen and (max-width: 767px) {
  .itemimg {
    width: 100%;
    // float: left;
    margin: 2%;
  }
}
.cooperative {
  text-align: center;
  padding-top: 80px;
  display: flex;
  // min-width: 1200px;
}
.container {
  width: 96%;
  padding: 0 0 50px 0;
  background-color: #fdfffc;
  margin: 0 auto;
  max-width: 1200px;
  .lister {
    position: relative;
    animation-name: FadeDown;
    animation-duration: 1.5s;
    opacity: 1 !important;
  }
  .list {
    opacity: 0;
    text-align: center;
    margin-bottom: 30px;
    .title {
      font-size: 27px;
      color: #333;
    }
    .text {
      color: #818181;
    }
  }
  .partner {
    padding: 10px 0 30px 0;
    width: 96%;
    max-width: 1200px;
    margin: 0 auto;
    // text-align: center;
    // opacity: 0;
    .itemer {
      visibility: visible;
      animation-name: FadeUpone;
      animation-duration: 1.2s;
      animation-delay:1.2s;
      animation-fill-mode: both;
      // opacity: 1 !important;
    }
    .item {
      // opacity: 0;
      width: 100%;
      // height: 298px;
      // border: 1px solid rgb(217, 217, 217);
      color: rgb(126, 126, 126);
      font-size: 14px;
      // line-height: 18px;
      // display: flex;
      .itemimg {
        border-width: 0px 0px 0px 0px;
        border-right-style: solid;
        border-right-color: #d9d9d9;
        // overflow: hidden;
        // display: block;
        // float: left;
        height: 65px;
        // width: 21%;
        float: left;
        // margin: 2%;
        // width: 50%;
        .itimg {
          // border-radius: 3%;
          // height: 100%;
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cooperative.vue